export const TTGlowingLogo = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="113" height="112" viewBox="0 0 113 112" fill="none">
      <g filter="url(#filter0_f_1505_1707)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M56.4258 106C84.04 106 106.426 83.6142 106.426 56C106.426 28.3858 84.04 6 56.4258 6C28.8115 6 6.42578 28.3858 6.42578 56C6.42578 83.6142 28.8115 106 56.4258 106ZM47.0508 43.5H31.4258V59.125H47.0508V43.5ZM64.2383 43.5V81H48.6133V43.5H64.2383ZM81.4258 31H65.8008V46.625H81.4258V31Z"
          fill="#F38744"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.4258 106C84.04 106 106.426 83.6142 106.426 56C106.426 28.3858 84.04 6 56.4258 6C28.8115 6 6.42578 28.3858 6.42578 56C6.42578 83.6142 28.8115 106 56.4258 106ZM47.0508 43.5H31.4258V59.125H47.0508V43.5ZM64.2383 43.5V81H48.6133V43.5H64.2383ZM81.4258 31H65.8008V46.625H81.4258V31Z"
        fill="#F38744"
      />
      <defs>
        <filter
          id="filter0_f_1505_1707"
          x="0.425781"
          y="0"
          width="112"
          height="112"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="3" result="effect1_foregroundBlur_1505_1707" />
        </filter>
      </defs>
    </svg>
  );
};
